@import "../../variables.scss";

.onboarding {
  &__wrapper {
    padding: 1rem;
    border-bottom: #d0d0d0 1px solid;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
    flex-direction: row;

    @media (max-width: $size-sm) {
      align-items: flex-start;
      flex-direction: column;
    }
  }

  &__wrapper:nth-child(even) {
    @media (max-width: $size-md) {
      background-color: rgba(0, 30, 83, 0.05);
    }
  }

  &__wrapper:last-child {
    border-bottom: 0;
  }

  &__btn {
    min-width: 126px;
    @media (max-width: $size-sm) {
      width: 100%;
    }
  }

  &__status {
    width: 93px;
    border: 2px solid;
    border-radius: 21px;
    text-transform: uppercase;
    text-align: center;
    padding: 7px 2px;
    font-family: Lato;
    font-size: 18px;
    letter-spacing: 0.34px;
    line-height: 22px;
    display: inline-block;
    font-weight: 700;
    height: 40px;
    flex-shrink: 0;
    @media (max-width: $size-md) {
      order: 1;
      max-height: 40px;
    }
  }
}

.buttonSubmit {
  width: 30%;
}

.buttonContainer {
  display: flex;
  width: 100%;
  padding: 1rem 0.5rem;
  margin: 0.5rem 0;
  justify-content: end;
}

@media screen and (max-width: $size-sm) {
  .buttonContainer {
    justify-content: center;
    width: 100%;
    padding: 0.5rem 0;
    padding-left: 10px;
  }
  .buttonSubmit {
    width: 100%;
    margin: 0 1rem;
    height: 50px;
  }
}

.submitButtonDesktop {
  width: 60%;
  display: flex;
  text-align: start;
  margin-right: 1.5rem;
}

@media only screen and (max-width: 576px) {
  .submitButtonDesktop {
    visibility: hidden;
    height: 0;
    width: 0;
    margin: 0;
  }
}

